<template>
    <section class="panel-body">
        <div class="row">
            <div class="col-md-4">
                <div class="alert flat">
                    <h4><i class="fa fa-info-circle"></i> Sistema de Nível <i class="fa fa-sitemap float-right"></i>
                    </h4>
                    <p>
                        O sistema de níveis é similar ao nível hierarquico do tipo árvore, assim como você encontra nos sistemas operacionais.

                    </p> 
                </div>
                <div class="alert flat">
                    <h4><i class="fa fa-info-circle"></i> Como funciona <i class="fa fa-lamp float-right"></i>
                    </h4>
                    <p>À partir do momento que você cria uma pasta e atrela um usuário de sua corporação ao nível, ele poderá visualizar arquivos e interagir nos nível que for selecionado ou  níveis inferiores
                    </p>
                    <small>Clique com o botão direto em cima das pastas para ver as opções</small>
                   
                </div>
            </div>
            <div class="col-md-8">
                <br>
                <folder-explorer style="min-height:70vh" ref="FolderExplorer" @toggle="changeOrder"
                    @nodeclick="selectNode" @drop="changeOrder" @nodecontextmenu="showContextMenu"
                    v-model="nestableItems">
                    <template slot="toggle" slot-scope="{ node }">
                        <a href="#" class="fa text-dark"
                            :class="{'fa-plus': !node.isExpanded, 'fa-minus': node.isExpanded}"></a>
                    </template>
                    <template slot="title" slot-scope="{ node }">
                        &nbsp;&nbsp;<span style="{cursor: -webkit-grab; cursor: move}" class="item-icon">
                            <i class="fa fa-file" v-if="node.isLeaf"></i>
                            <i class="fa fa-2x text-yellow"
                                :class="{'fa-folder': !node.children.length || !node.isExpanded, 'fa-folder-open': node.children.length && node.isExpanded}"
                                v-if="!node.isLeaf"></i>
                        </span>
                        {{ node.title }}
                    </template>
                    <template slot="draginfo">
                        Nível: {{selectedLevel.title}}
                    </template>
                </folder-explorer>
            </div>
            <ul class="contextmenu" ref="contextmenu" v-show="contextMenuIsVisible">
                <li @click="prepareRequest('STORE')"><i class="fa fa-plus-circle"></i> Adicionar Nível</li>
                <li @click="prepareRequest('UPDATE')"><i class="fa fa-edit"></i> Editar Nível</li>
                <li @click="prepareRequest('DELETE')"><i class="fa fa-trash"></i> Remover Nível</li>
                <!--  <li @click="pegarCaminho()"><i class="fa fa-cut"></i> Pegar Caminho</li> -->
            </ul>
        </div>
        <m-folder ref="mFolder" @updateData="updateLevels"></m-folder>
    </section>

</template>

<script>
    import mFolder from './components/m-folder';
    export default {
        components: {
            mFolder
        },
        data() {
            return {
                contextMenuIsVisible: false,
                selectedNodesTitle: '',
                loading: false,
                visible: false,
                top: 0,
                left: 0,
                selectedLevel: {
                    title: null
                },
                folder: {
                    parent: null,
                    operation: 'STORE',
                    id: null,
                    title: null,
                    children: []
                },
                nestableItems: []
            }
        },
        beforeMount() {            
            if (!this.allow('NIVEIS')) {
                this.$router.push('/home');
            }
        },
        mounted() {
            this.updateLevels();
        },
        watch: {
            contextMenuIsVisible(value) {
                if (value) {
                    document.body.addEventListener('click', this.closeMenu);
                } else {
                    document.body.removeEventListener('click', this.closeMenu);
                }
            }
        },
        methods: {
            updateLevels() {
                this.nestableItems = _.cloneDeep(this.$store.state.user.data.empresa.empresa_niveis);
            },
            prepareRequest(payload) {
                if (payload === 'DELETE') {
                    this.$refs.mFolder.folder = _.cloneDeep(this.folder);
                    this.$refs.mFolder.destroyLevel();
                    return
                }
                this.$refs.mFolder.folder = _.cloneDeep(this.folder);
                if (payload == 'STORE') {
                    this.$refs.mFolder.folder.title = null;
                }
                this.$refs.mFolder.folder.children = this.folder.children;
                this.$refs.mFolder.folder.operation = payload;
                setTimeout(function () {
                    $('#Nome').focus();
                }, 500);
                $('#ModalEditarNivel').modal('toggle');
            },
            openMenu(node, e) {
                this.$refs.FolderExplorer.select(node.path);
                this.selectedLevel = selectFolder;
                this.folder = _.cloneDeep(selectFolder);
                this.folder.parent = selectFolder.id;
                this.folder.parentText = selectFolder.title;
                this.visible = true;
                this.left = e.clientX;
                this.top = e.clientY;
                this.$forceUpdate();
            },
            closeMenu() {
                this.contextMenuIsVisible = false;
                let folder = this.deepSearch(this.nestableItems, this.selectedLevel.id);
                folder.isSelected = false;
                this.selectedLevel = {}
            },
            changeOrder(node, event) {
                if (!node[0]) {
                    return;
                }
                let request = {
                    niveis: this.nestableItems,
                    id: node[0].id
                }
                if (JSON.stringify(this.nestableItems) == JSON.stringify(this.$store.state.user.data.empresa
                        .empresa_niveis)) {
                    console.log('same order');
                    return;
                }
                this.$store.dispatch('ordenarNivel', request).then(response => {
                    this.$store.commit('SET_EMPRESA_NIVEIS', response.order);
                    this.updateLevels();
                });
            },
            flatFilter(nestedProp, compareKey, compareId, arr) {
                return arr.filter(o => {
                    const keep = o[compareKey] != compareId;
                    if (keep && o[nestedProp]) {
                        o[nestedProp] = this.flatFilter(nestedProp, compareKey, compareId, o[nestedProp]);
                    }
                    return keep;
                });
            },
            pegarCaminho() {
                var id = this.selectedLevel.id;
                let teste = _.cloneDeep(this.nestableItems);
                let res = teste.filter(function f(o) {
                    if (o.id == id) return true
                    if (o.children) {
                        return (o.children = o.children.filter(f)).length
                    }
                });
                let path = this.pegarNome(res, '', this.selectedLevel.id);
                alert(path);
            },
            pegarNome(arr, path, id) {
                arr.map(item => {
                    path += '/' + item.title;
                    if (item.id == id) {
                        return path;
                    }
                    //if (item.children.length > 0) {
                    path = this.pegarNome(item.children, path, id);
                    // }
                })
                return path;
            },
            searchTree(tree, nodesProp, prop, value) {
                var i, f = null; // iterator, found node
                if (Array.isArray(tree)) { // if entry object is array objects, check each object
                    for (i = 0; i < tree.length; i++) {
                        f = this.searchTree(tree[i], nodesProp, prop, value);
                        if (f) { // if found matching object, return it.
                            return f;
                        }
                    }
                } else if (typeof tree === 'object') { // standard tree node (one root)
                    if (tree[prop] !== undefined && tree[prop] !== value) {
                        return tree; // found matching node
                    }
                }
                if (tree[nodesProp] !== undefined && tree[nodesProp].length >
                    0) { // if this is not maching node, search nodes, children (if prop exist and it is not empty)
                    return this.searchTree(tree[nodesProp], nodesProp, prop, value);
                } else {
                    return null; // node does not match and it neither have children
                }
            },
            containsInNestedObjectDF(obj, val) {
                if (obj === val) {
                    return obj;
                }
                //const keys = obj instanceof Object ? Object.keys(obj) : [];
                for (const key of keys) {
                    let objval = obj[key];
                    const isMatch = this.containsInNestedObjectDF(objval, val);
                    if (isMatch) {
                        objval = null;
                        return null;
                    }
                }
                return null;
            },
            deepSearch(data, value, key = 'id', sub = 'children', tempObj = {}) {
                if (value && data) {
                    data.find((node) => {
                        if (node[key] == value) {
                            tempObj.found = node;
                            return node;
                        }
                        return this.deepSearch(node[sub], value, key, sub, tempObj);
                    });
                    if (tempObj.found) {
                        return tempObj.found;
                    }
                }
                return false;
            },
            showContextMenu(node, event) {
                this.$refs.FolderExplorer.select(node.path);
                this.selectedLevel = node;
                this.folder = _.cloneDeep(node);
                this.folder.parent = node.id;
                this.folder.parentText = node.title;
                event.preventDefault();
                this.contextMenuIsVisible = true;
                const $contextMenu = this.$refs.contextmenu;
                $contextMenu.style.left = event.clientX + 'px';
                $contextMenu.style.top = event.clientY + 'px';
            },
            selectNode(node, event) {
                this.selectedLevel = _.cloneDeep(node);
            },
            removeNode() {
                this.contextMenuIsVisible = false;
                const $slVueTree = this.$refs.FolderExplorer;
                const paths = $slVueTree.getSelected().map(node => node.path);
                $slVueTree.remove(paths);
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    .sl-vue-tree {
        position: relative;
        cursor: default;
        -webkit-touch-callout: none;
        /* iOS Safari */
        -webkit-user-select: none;
        /* Safari */
        -khtml-user-select: none;
        /* Konqueror HTML */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* Internet Explorer/Edge */
        user-select: none;
    }

    .sl-vue-tree-root>.sl-vue-tree-nodes-list {
        overflow: hidden;
        position: relative;
        padding-bottom: 4px;
    }

    .sl-vue-tree-selected>.sl-vue-tree-node-item {
        background-color: rgba(100, 100, 255, 0.5);
    }

    .sl-vue-tree-node-list {
        position: relative;
        display: flex;
        flex-direction: row;
    }

    .sl-vue-tree-node-item {
        position: relative;
        display: flex;
        flex-direction: row;
    }

    .sl-vue-tree-node-item.sl-vue-tree-cursor-inside {
        outline: 1px solid rgba(100, 100, 255, 0.5);
    }

    .sl-vue-tree-gap {
        width: 20px;
        min-height: 1px;

    }

    .sl-vue-tree-sidebar {
        margin-left: auto;
    }

    .sl-vue-tree-cursor {
        position: absolute;
        border: 1px solid rgba(100, 100, 255, 0.5);
        height: 1px;
        width: 100%;
    }

    .sl-vue-tree-drag-info {
        position: absolute;
        background-color: rgba(0, 0, 0, 0.5);
        opacity: 0.5;
        margin-left: 20px;
        margin-bottom: 20px;
        padding: 5px 10px;
    }

    .contextmenu {
        position: absolute;
        background-color: white;
        color: black;
        border-radius: 2px;
        cursor: pointer;
    }

    .contextmenu>ul {
        padding: 10px;
    }

    .contextmenu>ul:hover {
        background-color: rgba(100, 100, 255, 0.5);
    }

    .last-event {
        color: white;
        background-color: rgba(100, 100, 255, 0.5);
        padding: 10px;
        border-radius: 2px;
    }

    .contextmenu {
        margin: 0;
        background: #fff;
        position: absolute;
        list-style-type: none;
        padding: 5px 0;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 400;
        color: #333;
        box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);

        li {
            margin: 0;
            padding: 7px 16px;
            cursor: pointer;

            &:hover {
                background: #eee;
            }
        }
    }
</style>
<style>
    .contextmenu {
        position: absolute;
        background-color: white;
        color: black;
        border-radius: 2px;
        cursor: pointer;
    }

    .contextmenu>div {
        padding: 10px;
    }

    .contextmenu>div:hover {
        background-color: rgba(100, 100, 255, 0.5);
    }


    .last-event {
        color: white;
        background-color: rgba(100, 100, 255, 0.5);
        padding: 10px;
        border-radius: 2px;
    }

    .tree-container {
        flex-grow: 1;
    }

    .sl-vue-tree.sl-vue-tree-root {
        flex-grow: 1;
        overflow-x: hidden;
        overflow-y: auto;
        height: 300px;
    }


    .json-preview {
        flex-grow: 1;
        margin-left: 10px;
        background-color: #13242d;
        border: 1px solid black;
        padding: 10px;
    }
</style>